export default __webpack_public_path__ + "static/media/pay.64a9e955.png";